import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  checkUserExists,
  getOtp1,
  login,
  RegisterNewUser,
  ValidateOtp,
} from "../services/Auth";
import signupImage from "../assets/workers.png";
import { showSnackbar } from "./snackbar";
import { getProfessions } from "../services/Spares";
import { Form, Input, Button, Select, Row, Col } from "antd";
import { CartContext } from "../contextApi/CartContext";
const { Option } = Select;

export default function SignUp({ switchToLogin, onSuccess, onClose }) {
  const navigate = useNavigate();
  const { setUserId } = React.useContext(CartContext);
  const [form] = Form.useForm();

  const identifier = Form.useWatch("identifier", form);
  const usertype = Form.useWatch("usertype", form);
  const firstname = Form.useWatch("first_name", form);
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState("FORM"); // FORM -> OTP -> REGISTER
  const [pendingData, setPendingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitloading, setsubmitLoading] = useState(false);
  const [profloading, setProfLoading] = useState(false);
  const [professions, setProfessions] = useState([]);
  const [profession, setProfession] = useState(professions[0]);
  const [isEmail, setIsEmail] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(0);
  const [error, setError] = useState("");
  const [mobileerr, setMobileError] = useState("");
  const [mailerror, setMailError] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [mobile, setMobile] = useState("");
  const otpRefs = useRef([]);
  /* ---------- Detect Email / Mobile and Auto Send OTP ---------- */
  const lastCheckedRef = useRef("");

  useEffect(() => {
    if (!identifier) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailInput = emailRegex.test(identifier);

    setIsEmail(isEmailInput);

    const timeout = setTimeout(() => {
      const isValidEmail = isEmailInput;
      const isValidMobile = /^[0-9]{10}$/.test(identifier);

      if ((isValidEmail || isValidMobile) && lastCheckedRef.current !== identifier) {
        lastCheckedRef.current = identifier;

        checkUserAndSendOtp(identifier, isEmailInput);
      }
    }, 800);

    return () => clearTimeout(timeout);
  }, [identifier]);

  useEffect(() => {
    loadProf();
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      setReferralCode(ref);
      console.log('ref', ref)
    }
  }, [form]);

  /* ---------- OTP Timer ---------- */
  useEffect(() => {
    if (!otpSent || timer === 0) return;
    const interval = setInterval(() => setTimer((t) => t - 1), 1000);
    return () => clearInterval(interval);
  }, [otpSent, timer]);

  /* ---------- APIs ---------- */
  const checkmobileUser = async (value) => {
    setLoading(true);
    setMobileError("");
    try {
      // First check if user exists
      const checkRes = await checkUserExists({ param: value });

      if (checkRes.status === 200) {
        setMobileError("User already exists. Please sign in.");
        setLoading(false);
        return;
      }
    } catch {
    } finally {
    }
    setLoading(false);
  };


  const checkUser = async (value) => {
    setLoading(true);
    setMailError("");
    try {
      // First check if user exists
      const checkRes = await checkUserExists({ param: value });

      if (checkRes.status === 200) {
        setMailError("User already exists. Please sign in.");
        setLoading(false);
        return;
      }
    } catch {
    } finally {
    }
    setLoading(false);
  };

  const checkUserAndSendOtp = async (value, isEmailFlag) => {
    setLoading(true);
    try {
      // First check if user exists
      const checkRes = await checkUserExists({ param: value });

      if (checkRes.status === 200) {
        setError("User already exists. Please sign in.");
        setLoading(false);
        return;
      }

      // If user doesn't exist, proceed to send OTP
      // const otpRes = await getOtp1({
      //   email: isEmailFlag ? value : "",
      //   mobile: isEmailFlag ? "" : value,
      //   type:'register',
      // });

      // if (otpRes.status === 200) {
      //   setStep("OTP");
      //   setOtpSent(true);
      //   setTimer(300); // 5 minutes timer
      //   setError("");
      // } else {
      //   setError("Failed to send OTP. Please try again.");
      // }
    } catch (error) {
      console.error("Error:", error);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

 const onRegister = async (data) => {
  if (mobileerr || mailerror) return;

  setsubmitLoading(true);
  setError("");

  try {
    // 1. Check if user already exists
    const checkRes = await checkUserExists({ param: mobile });
    if (checkRes?.status === 200) {
      setMobileError("User already exists. Please sign in.");
      setError("User already exists. Please sign in.");
      setsubmitLoading(false);
      return;
    }
  } catch (e) {
    // API throws / 404 => user not found => continue registration
  }

  // 2. Build payload
  const registrationEmail = `${mobile.trim()}@pixel.com`;
  const payload = {
    first_name: data.first_name,
    username: registrationEmail,
    email: registrationEmail,
    mobile: mobile,
    password: "123456",
    usertype: data.usertype || "Customer",
    module_assign: "0",
    refer: data.referralCode || referralCode || "",
    extra2: data.profession,
    extra1: data.usertype === "Dealer" ? data.gst : "",
    firmname: data.usertype === "Dealer" ? data.firmname : "",
  };

  // 3. Send OTP first — register only after OTP verification
  setPendingData(payload);
  setLoading(true);
  try {
    const otpRes = await getOtp1({ mobile, type: "register" });
    if (otpRes?.status === 200) {
      setStep("OTP");
      setOtpSent(true);
      setTimer(300);
      setOtp(Array(6).fill(""));
      setError("");
      if (otpRefs.current[0]) otpRefs.current[0].focus();
    } else {
      setError("Failed to send OTP. Please try again.");
    }
  } catch {
    setError("Failed to send OTP. Please try again.");
  } finally {
    setLoading(false);
    setsubmitLoading(false);
  }
};

  const verifyOtp = async () => {
    const code = otp.join("");
    if (code.length !== 6) return setError("Enter 6 digit OTP");

    setLoading(true);
    setError("");
    try {
      const res = await ValidateOtp({ mobile: mobile, otp: code, type: "register" });
      if (res.data.Status === "done") {
        setError("");
        await completeRegistration();
      } else {
        setError("Invalid OTP");
      }
    } catch {
      setError("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };




 const completeRegistration = async (dataToSend) => {
  const payload = dataToSend || pendingData;
  if (!payload) return;

  setsubmitLoading(true);
  setLoading(true);
  setError("");
  try {
    const res = await RegisterNewUser(payload);
    if (res?.status === 200) {
      const loginResponse = await login({
        email: payload.mobile,
        password: "123456",
      });

      if (loginResponse?.status !== "Ok" || !loginResponse?.access) {
        throw new Error("Automatic login failed");
      }

      localStorage.setItem("token", loginResponse.access);
      localStorage.setItem("userId", String(loginResponse.userid));
      localStorage.setItem("userName", loginResponse.username || "");
      localStorage.setItem("userType", loginResponse.usertype || "");
      localStorage.setItem("firmName", loginResponse.firmname || "");
      localStorage.setItem("firstName", loginResponse.first_name || "");
      localStorage.setItem("mobile", loginResponse.Mobile || payload.mobile);
      localStorage.setItem("email", loginResponse.email || payload.email);
      localStorage.setItem("loginCount", loginResponse.login_count || "0");
      localStorage.setItem("GST", loginResponse.GST || "");
      localStorage.setItem("ReferalCode", loginResponse["Referal Code"] || "");
      localStorage.setItem("modules", loginResponse.Modules || "");

      setUserId(loginResponse.userid);
      showSnackbar("success", "User Registered Successfully");
      onSuccess();
      navigate("/");
    } else {
      setError("Registration failed");
    }
  } catch {
    setError("Registration failed");
  } finally {
    setsubmitLoading(false);
    setLoading(false);
  }
};

  const loadProf = async () => {
    try {
      setProfLoading(true);
      const res = await getProfessions();
      console.log("prof", res.data.data);
      setProfessions(res.data.data || []);
    } catch (e) {
      console.error("Error loading product spares:", e);
    } finally {
      setProfLoading(false);
    }
  };
  // const ProfessionDropdown = ({ value, onChange, professions }) => {
  //   return (
  //     <Select
  //       value={value}
  //       onChange={onChange}
  //       style={{ width: "100%", padding: 12, borderRadius: 20, marginBottom: 10 }}
  //       placeholder="Select Profession"
  //     >
  //       {professions.map((item) => (
  //         <Option key={item.id} value={item.name}>
  //           {item.name}
  //         </Option>
  //       ))}
  //     </Select>
  //   );
  // };

  /* ---------- OTP Input ---------- */

  const handleOtpChange = (val, i) => {
    if (!/^\d?$/.test(val)) return;
    const copy = [...otp];
    copy[i] = val;
    setOtp(copy);
    if (val && i < 5) otpRefs.current[i + 1].focus();
  };

  const handleKeyDown = (e, i) => {
    if (e.key === "Backspace" && !otp[i] && i > 0) {
      otpRefs.current[i - 1].focus();
    }
  };

  // Function to resend OTP
  const resendOtp = async () => {
    if (timer > 0) return;

    setLoading(true);
    try {
      const res = await getOtp1({ mobile, type: "register" });
      if (res.status === 200) {
        setOtpSent(true);
        setTimer(300);
        setOtp(Array(6).fill("")); // Clear OTP fields
        setError("");
        // Focus on first OTP input
        if (otpRefs.current[0]) {
          otpRefs.current[0].focus();
        }
      } else {
        setError("Failed to resend OTP");
      }
    } catch {
      setError("Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
    @media (max-width: 900px) {
      .signup-left {
        display: none !important;
      }

      .signup-container {
        flex-direction: column !important;
        align-items: center !important;
        justify-content: flex-start !important;
        width: 95% !important;
        max-width: 520px !important;
        max-height: calc(100vh - 20px) !important;
        overflow-y: auto !important;
        margin-top: 10px !important;
      }

      .signup-right {
        width: 100% !important;
        padding: 25px 20px !important;
        border-radius: 16px !important;
        justify-content: flex-start !important;
      }

      .signup-card {
        top: 10px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        max-height: calc(100vh - 20px) !important;
        overflow-y: auto !important;
      }
    }

    .signup-right .ant-form {
      width: 100%;
      max-width: 520px;
      margin: 0 auto;
    }

    .signup-right .ant-form-item {
      margin-bottom: 15px;
    }

    .signup-right .ant-input,
    .signup-right .ant-input-password,
    .signup-right .ant-select-selector {
      border-radius: 8px;
    }

    .signup-right .ant-btn {
      width: 100%;
      border-radius: 10px;
      background: #0E5E7C;
      color: #fff;
    }
  `}
      </style>
      <div style={styles.overlay}>
        <div className="signup-container" style={{ borderRadius: "16px" }}  >
          {/* <div className="signup-left" style={styles.left}>
            <img src={signupImage} alt="Sign Up" style={styles.leftImage} />
          </div> */}

          <div className="signup-right" style={styles.right}>
            <span style={styles.closeBtn} onClick={onClose}>
              ✕
            </span>
            <h2 style={{ marginBottom: "20px", fontWeight: 400, color: "black", fontSize: "24px" }}>Create Account</h2>
            {error && <p style={styles.error}>{error}</p>}

            {step === "OTP" && (
              <>
                <div style={styles.otpUserDetails}>
                  <div><strong>Name:</strong> {pendingData?.first_name}</div>
                  <div><strong>Mobile:</strong> {pendingData?.mobile}</div>
                </div>
                <p style={styles.otpText}>
                  OTP sent to mobile: {mobile}
                </p>
                <div style={styles.otpInputs}>
                  {otp.map((v, i) => (
                    <input
                      key={i}
                      ref={(el) => (otpRefs.current[i] = el)}
                      value={v}
                      maxLength={1}
                      onChange={(e) => handleOtpChange(e.target.value, i)}
                      onKeyDown={(e) => handleKeyDown(e, i)}
                      style={styles.otpBox}
                      autoFocus={i === 0}
                    />
                  ))}
                </div>

                <button
                  style={styles.button}
                  onClick={verifyOtp}
                  disabled={otp.join("").length !== 6 || loading}
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>

                <p style={styles.timer}>
                  {timer > 0 ? (
                    <>
                      Resend in {Math.floor(timer / 60)}:
                      {(timer % 60).toString().padStart(2, "0")}
                    </>
                  ) : (
                    <span onClick={resendOtp} style={styles.resendLink}>
                      Resend OTP
                    </span>
                  )}
                </p>
              </>
            )}

            {step === "FORM" && (
              <Form form={form} layout="vertical" onFinish={onRegister}>
                <Row gutter={16}>
                  {/* Name */}
                  <Col span={24} style={{ order: 1 }}>
                    <Form.Item
                      label="Name"
                      name="first_name"
                      rules={[{ required: true, message: "Please enter your name" }]}
                    >
                      <Input placeholder="Enter your name" />
                    </Form.Item>
                  </Col>

                  {/* Email */}
                  {/* <Col xs={24} md={12}>
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[
                        { required: true, message: "Please enter your email" },
                        { type: "email", message: "Enter a valid email" },
                      ]}
                      validateStatus={mailerror ? "error" : undefined}
                      help={mailerror ? "User already exists" : undefined}
                    >
                      <Input
                        placeholder="Enter your email"
                        onChange={(e) => {
                          const value = e.target.value;
                          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                          if (emailRegex.test(value)) {
                            checkUser(value);
                          }
                        }}
                      />
                    </Form.Item>
                  </Col> */}

                  {/* Mobile */}
                  <Col span={24} style={{ order: 2 }}>
                    <Form.Item
                      label="Mobile"
                      name="mobile"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your mobile number",
                        },
                      ]}
                      validateStatus={mobileerr ? "error" : undefined}
                      help={mobileerr ? "User already exists" : undefined}
                    >
                      <Input
                        value={mobile}
                        onChange={(e) => {
                          const value = e.target.value;

                          if (!/^\d*$/.test(value)) return;

                          setMobile(value);

                          if (value.length === 10) {
                            checkmobileUser(value);
                          }
                        }}
                        placeholder="Enter Mobile"

                        disabled={loading}
                      />
                    </Form.Item>

                    {loading && (
                      <p style={styles.loadingText}>
                        Checking and sending OTP...
                      </p>
                    )}
                  </Col>

                  {/* Profession */}
                  {/* <Col xs={24} md={12}>

                    <Form.Item
                      label="Referral Code"
                      name="referralCode"
                    >
                      <Input placeholder="Enter referral code (optional)" />
                    </Form.Item>
                  </Col> */}

                  {/* User Type */}
                  {/* <Col xs={24} md={12}>
                    <Form.Item
                      label="I want to register as"
                      name="usertype"
                      initialValue="Customer"
                    >
                      <Select placeholder="Select user type">
                        <Option value="Customer">Customer</Option>
                        <Option value="Dealer">Dealer</Option>
                      </Select>
                    </Form.Item>
                  </Col> */}

                  {/* GST - Only for Dealer */}
                  {/* {usertype === "Dealer" && (
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="GST Number"
                        name="gst"
                        rules={[
                          { required: true, message: "Please enter your GST number" },
                          { pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, message: "Enter a valid GST number" },
                        ]}
                      >
                        <Input placeholder="Enter GST number" />
                      </Form.Item>
                    </Col>
                  )}
                   {usertype === "Dealer" && (
                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Firm Name"
                        name="firmname"
                        rules={[
                          { required: true, message: "Please enter your Firm Name" },
                        ]}
                      >
                        <Input placeholder="Enter Firm Name" />
                      </Form.Item>
                    </Col>
                  )} */}

                  {/* Referral Code
                  <Col xs={24} md={12}>

                    <Form.Item label="Profession" name="profession">
                      <Select placeholder="Select Profession (Optional)">
                        {professions.map((item) => (
                          <Option key={item.id} value={item.profession}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col> */}

                  {/* Submit Button */}
                  <Col span={24} style={{ order: 5 }}>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        block
                        loading={submitloading}
                        disabled={submitloading || !firstname || mobile.length !== 10}
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            )}

            {/* <p style={styles.loginText}>
              Already have an account?{" "}
              <span onClick={switchToLogin} style={styles.loginLink}>
                Sign In
              </span>
            </p> */}
          </div>
        </div>
      </div>
    </>
  );
}

/* ---------- STYLES (MATCH LOGIN) ---------- */

const styles = {
  card: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    alignItems: "stretch",
    justifyContent: "center",
    width: "900px",
    maxWidth: "95%",
    maxHeight: "95vh",
    backgroundColor: "#fff",
    display: 'flex',
    overflow: "hidden",
    borderRadius: "16px",
    zIndex: 10001,
  },
  closeBtn: {
    position: "absolute",
    top: "5px",
    right: "15px",
    fontSize: "22px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "#131212",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(0,0,0,0.25)",
    zIndex: 9999,
    padding: "24px",
    overflowY: "auto",
  },
  container: {
    display: "flex",
    width: "100%",
    maxWidth: "860px",
    minHeight: "520px",
    maxHeight: "95vh",
    background: "#fff",
    borderRadius: "28px",
    overflow: "hidden",
    position: "relative",
    fontFamily: "Segoe UI, Arial, sans-serif",
    boxShadow: "0 30px 90px rgba(0,0,0,0.14)",
  },
  left: {
    flex: "0 0 45%",
    minWidth: "240px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f5f8ff",
    padding: "24px",
  },
  leftImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  right: {
    borderRadius: "4%",
    flex: "0 0 55%",
    minWidth: "300px",
    padding: "44px 36px",
    position: "relative",
    overflowY: "auto",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  imageContainer: {
    flex: 1,
    display: "flex",
    height: '100%',
    alignItems: "center",
    justifyContent: "center",
    background: "#f7f7f7",
  },
  image: { maxWidth: "100%", height: "auto" },
  formContainer: { padding: "30px 25px", width: '50%', overflowY: 'auto' },
  title: { textAlign: "center", marginBottom: "20px" },

  input: {
    width: "100%",
    padding: "14px 18px",
    borderRadius: "30px",
    border: "1px solid #ddd",
    marginBottom: "15px",
  },
  passwordWrapper: { position: "relative" },
  passwordInput: {
    width: "100%",
    padding: "14px 45px 14px 18px",
    borderRadius: "30px",
    border: "1px solid #ddd",
  },
  eyeIcon: {
    position: "absolute",
    right: "18px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
  },
  otpInputs: { display: "flex", justifyContent: "center", gap: "5px" },
  otpUserDetails: {
    width: "100%",
    marginBottom: "16px",
    padding: "12px 14px",
    borderRadius: "8px",
    background: "#f5f8fa",
    color: "#222",
    lineHeight: 1.7,
  },
  otpBox: {
    width: "45px",
    height: "45px",
    textAlign: "center",
    fontSize: "18px",
    borderRadius: "8px",
    border: "1px solid #ddd",
  },
  otpText: { textAlign: "center", marginBottom: "10px" },
  button: {
    width: "100%",
    padding: "14px",
    borderRadius: "30px",
    backgroundColor: "#000",
    color: "#fff",
    border: "none",
    marginTop: "10px",
    cursor: "pointer",
  },
  timer: {
    textAlign: "center",
    marginTop: "10px",
    fontSize: "14px",
  },
  resendLink: {
    color: "#0068b4",
    cursor: "pointer",
    fontWeight: "600",
  },
  loginText: { textAlign: "center", marginTop: "15px" },
  loginLink: { fontWeight: "600", cursor: "pointer", color: "#0068b4" },
  error: {
    color: "red",
    textAlign: "center",
    fontSize: "14px",
    marginBottom: "10px",
  },
  loadingText: {
    textAlign: "center",
    color: "#666",
    fontSize: "14px",
    marginTop: "-10px",
    marginBottom: "10px",
  },

};
